// extracted by mini-css-extract-plugin
export default {"layout":"BonusMultiviewBonusDetailsPopup__layout--hzE","loader":"BonusMultiviewBonusDetailsPopup__loader--A0M"};